import { useRequiredParams } from '@pba/react-router';
import { LandingLayout } from 'layouts';
import { isMongoObjectId } from 'common/utils';
import { PublicEvent, PublicProgramEvent } from 'features/events';
import { Footer, Header, type HeaderItem } from 'features/onboarding';
import type { OnboardingLocationState } from 'pages/types';
import { useOnboardingNavigation } from '../../hooks';

const PagePublicEvent = () => {
  const { eventId } = useRequiredParams<{ eventId: string }>();
  // eslint-disable-next-line @typescript-eslint/unbound-method -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
  const { onNavigateToPrimaryLogin } = useOnboardingNavigation<OnboardingLocationState>();

  const headerButtons: HeaderItem[] = [
    {
      label: 'Log in',
      async onClick() {
        await onNavigateToPrimaryLogin({ referrer: window.location.pathname });
      },
      type: 'primary',
    },
  ];

  return (
    <LandingLayout
      contentRight={
        isMongoObjectId(eventId) ? <PublicEvent eventId={eventId} /> : <PublicProgramEvent eventId={eventId} />
      }
      footer={<Footer />}
      header={<Header items={headerButtons} />}
      type="public-detail"
    />
  );
};

export default PagePublicEvent;
